export const CONFIRM_POLY_PLANNING_LEVEL_KEY = 'jbp-poly-planning-level-confirm'

export const ConfirmPolyPlanningLevelDialogTranslations = {
  title: `${CONFIRM_POLY_PLANNING_LEVEL_KEY}--title`,

  apply: `${CONFIRM_POLY_PLANNING_LEVEL_KEY}--apply`,
  cancel: `${CONFIRM_POLY_PLANNING_LEVEL_KEY}--cancel`,
}

export default ConfirmPolyPlanningLevelDialogTranslations
